import { LocalizedText } from '../models/user-identification';

type ResolveLocalizedTextFn = (
	value?: LocalizedText | null,
	options?: { crossLocaleFallback?: boolean },
) => string;

/** Indica si el mapa/string FINISH tiene texto en algún locale. */
export function hasFinishLocalizedText(value: LocalizedText | null | undefined): boolean {
	if (value == null) {
		return false;
	}
	if (typeof value === 'string') {
		return value.trim().length > 0;
	}
	return Object.values(value).some((v) => v != null && String(v).trim().length > 0);
}

/** Bloque pending sin configurar en workflow (title y description vacíos/null en API). */
export function isPendingFinishMessagesUnconfigured(
	pendingTitle: LocalizedText | null | undefined,
	pendingDescription: LocalizedText | null | undefined,
): boolean {
	return !hasFinishLocalizedText(pendingTitle) && !hasFinishLocalizedText(pendingDescription);
}

/**
 * Mensaje FINISH custom por locale actual; si falta, i18n (sin caer a otro idioma).
 */
export function resolveFinishResultMessage(
	resolveLocalizedText: ResolveLocalizedTextFn,
	instant: (key: string) => string,
	value: LocalizedText | null | undefined,
	fallbackI18nKey: string,
): string {
	const custom = resolveLocalizedText(value, { crossLocaleFallback: false })?.trim();
	if (custom) {
		return custom;
	}
	return fallbackI18nKey ? instant(fallbackI18nKey) : '';
}

/**
 * Descripción pending: default i18n solo si title y description no vienen configurados;
 * si hay title custom y description null, no muestra subtítulo.
 */
export function resolvePendingFinishDescription(
	resolveLocalizedText: ResolveLocalizedTextFn,
	instant: (key: string) => string,
	pendingTitle: LocalizedText | null | undefined,
	pendingDescription: LocalizedText | null | undefined,
): string {
	if (isPendingFinishMessagesUnconfigured(pendingTitle, pendingDescription)) {
		return instant('FINISH.PENDING_DESCRIPTION');
	}
	return resolveFinishResultMessage(resolveLocalizedText, instant, pendingDescription, '');
}
